import { useMemo } from "react"
import Card from "src/shared/components/data-display/card/Card"
import { formatCurrency } from "src/shared/hooks/formatCurrency"

interface DataCards {
    title?: string
    number?: string
    percent?: string
}

const CardsGastosListFiltered = ({
    gastosDelMes,
    month,
    title,
    total
}: {
    gastosDelMes?: {
        title?: string
        number?: number
        percent?: string
    }[]
    month: number
    total?: number
    title: string
}) => {

    const dataCards: DataCards[] = useMemo(() => {
        if (gastosDelMes?.length) {
            return [
                {
                    title: `Total de gastos ${title}`,
                    number: `${formatCurrency(total || 0)}`,
                },
                ...gastosDelMes.map(g => ({
                    title: g.title,
                    number: `${formatCurrency(g.number || 0)}`,
                    percent: g.percent
                })),
            ]
        } else {
            return [{
                title: `Total de gastos ${title}`,
                number: `${formatCurrency(total || 0)}`,
            }]
        }
    }, [gastosDelMes])

    return (
        <>
            {dataCards.map((data, index) => (
                <Card
                    containerClassName={
                        month === 8 ? "card-gastos-big" : month >= 10 ? "card-gastos-big" : "card-gastos"
                    }
                    key={index}
                    title={data.title || ""}
                    number={(data.number + "") || "0"}
                    percent={data.percent}
                />
            ))}
        </>
    )
}

export default CardsGastosListFiltered
